import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

// Components
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'

// Pages
import Home from './pages/Home'
import OmOs from './pages/OmOs'
import Referencer from './pages/Referencer'
import Tilbud from './pages/Tilbud'
import NotFound from './pages/NotFound'
import Forbidden from './pages/Forbidden'

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-slate-50 text-slate-900 font-sans">
        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<OmOs />} />
            <Route path="/referencer" element={<Referencer />} />
            <Route path="/tilbud" element={<Tilbud />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  )
}

export default App
